module.exports = __webpack_public_path__ + "static/media/LC-backpack.42b9917f.png";